export const ADD_RETRIES: string = "ADD_RETRIES";
export const CLEAR_RETRIES: string = "CLEAR_RETRIES";

export function addRetries(retryKey:number,retryVal:string): IAddRetriesActionType {
    return { type: ADD_RETRIES, retryKey:retryKey,retryVal:retryVal};
}
export function clearRetries(): IClearRetriesActionType {
    return { type: CLEAR_RETRIES};
}


interface IAddRetriesActionType { type:string,retryKey:number,retryVal:string}
interface IClearRetriesActionType { type:string }